// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"XV","innerWrapper":"YV","tooltipWrapper":"ZV","icon":"_V","tooltip":"aW","content":"bW"};